/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ComponentReference from '../Utility/Component/ComponentReference/ComponentReference';
import ComponentBase from '../Utility/ComponentBase';
import StateComponent from './StateComponent';
import StateDispatcherData from './StateDispatcherData';
import StateEvent from './StateEvent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class StateDispatcher extends ComponentBase
{
    /** Array of [[StateComponentData]] to match state to handlers. */
    @property({ type: [StateDispatcherData], visible: true })
    private _stateDispatchers: StateDispatcherData[] = [];

    /** List of [[StateComponent]] and handlers for removing listeners. */
    private _stateHandlers: [StateComponent, cc.Component.EventHandler][] = [];

    /** @hidden */
    protected start(): void
    {
        super.start();

        this._stateDispatchers.forEach(dispatcher =>
        {
            let state: StateComponent
                = ComponentReference.Get(StateComponent, dispatcher.ReferenceGroup, dispatcher.InstanceID);

            if (!dispatcher.EventHandlers) { return; }

            for (let handler of dispatcher.EventHandlers)
            {
                state.StateManager.OnStateChange(state, this.getBoundStateEventHandler(handler));

                this._stateHandlers.push([state, handler]);
            }
        }, this);
    }

    /** @hidden */
    protected onDestroy(): void
    {
        if (this._stateHandlers) {
            for (let stateHandler of this._stateHandlers)
            {
                if (!stateHandler || !stateHandler[0] || !stateHandler[1]) { continue; }

                const state: StateComponent = stateHandler[0];
                const handler: cc.Component.EventHandler = stateHandler[1];

                state.StateManager.OffStateChange(state, this.getBoundStateEventHandler(handler));
            }
        }

        this._stateHandlers = [];
    }

    /**
     * Helper function for getting anonymous function from handler.
     * @param eventHandler Handler to execute.
     * @returns Function that calls emit on handler.
     */
    private getBoundStateEventHandler(eventHandler: cc.Component.EventHandler): (event: StateEvent) => void
    {
        if (!eventHandler) { return; }

        return (event: StateEvent) =>
        {
            eventHandler.emit(null);
        };
    }
}
